App.factory('FormResponse', ['restmod', restmod => {
  return restmod.model('/form_responses')
}])
